export const addPlural = (cond: boolean) => {
  return cond ? 's' : ''
}

export const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
